/* eslint-disable camelcase */

import {ExamCenter} from "./examCenter";
import {Invoice} from "./invoice";

/**
 * Session visée par une demande de tickets. Contexte seulement : les tickets
 * restent fongibles côté back, la session n'est pas une affectation.
 * Distincte de `ShortExamSession` qui ne porte pas la date.
 */
export class VoucherRequestSession {
    id: number;

    code: string;

    date: Date;

    constructor (data: any) {
        if (data) {
            this.id = data.id;
            this.code = data.code;
            if (data.date) this.date = new Date(data.date);
        }
    }
}

/** Rendu d'un statut : libellé affiché et couleur Bootstrap du badge. */
interface StatusDisplay {
    label: string;
    badgeClass: string;
}

const STATUS_DISPLAYS: {[status: string]: StatusDisplay} = {
    "pending": {"label": "En attente",
        "badgeClass": "badge-warning text-dark"},
    "confirmed": {"label": "Confirmée",
        "badgeClass": "badge-success"},
    "rejected": {"label": "Refusée",
        "badgeClass": "badge-danger"},
    "cancelled": {"label": "Annulée",
        "badgeClass": "badge-secondary"}
};

const UNKNOWN_STATUS: StatusDisplay = {"label": "Inconnu",
    "badgeClass": "badge-light"};

export class VoucherRequest {

    id: number;

    exam_center: ExamCenter;

    quantity: number;

    session: VoucherRequestSession = null;

    // Clé back : pending | confirmed | rejected | cancelled
    status: string;

    // Facture qui répond à la demande — null tant que la demande est en attente.
    invoice: Invoice = null;

    comment: string = null;

    requested_by: number = null;

    created_date: Date;

    constructor (data: any = null) {
        if (data != null) {
            this.id = data.id;
            this.quantity = data.quantity;
            this.status = data.status;
            this.comment = data.comment;
            this.requested_by = data.requested_by;

            if (data.exam_center) this.exam_center = new ExamCenter(data.exam_center);

            if (data.session) this.session = new VoucherRequestSession(data.session);

            if (data.invoice) this.invoice = new Invoice(data.invoice);

            if (data.created_date) this.created_date = new Date(data.created_date);
        }
    }

    private get statusDisplay (): StatusDisplay {
        return STATUS_DISPLAYS[this.status] ?? UNKNOWN_STATUS;
    }

    get statusLabel (): string {
        return this.statusDisplay.label;
    }

    get statusBadgeClass (): string {
        return this.statusDisplay.badgeClass;
    }

}
